


var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};

var bcSfFilterSettings = {
    general: {
      	numberFilterTree: 2,
      	filterTreeMobileStyle: 'style3'
    },
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutLabelHtml': '<span class="product-item__sold-out-badge"><span class="badge badge-danger">' + bcSfFilterConfig.label_basic.sold_out + '</span></span>',
    'saleLabelHtml': '<span class="product-item__sale-badge"><span class="badge badge-info">' + bcSfFilterConfig.label_basic.save_percent + ' {{itemPercent}}%</span></span>',
    'vendorHtml': '{{itemVendorLabel}}',

    // Grid Template
    'productGridItemHtml': '<div class="col-sm-3 product-item grid">' +
                              '<div class="card product-item__card">' +
                                '<div class="card-img-top product-item__card-image {{itemImageClasses}}">' +
                                  '<a href="{{itemUrl}}" title="{{itemTitle}}">' +
                                    '{{itemImages}}' +
                                  '</a>' +
                                  '{{itemLabels}}' +
                                '</div>' +
                                '<div class="card-body product-item__card-body text-center">' +
                                  '<p class="h5 card-title mb-0 product-item__title"><a href="{{itemUrl}}" title="{{itemTitle}}">{{itemTitle}}</a></p>' +
      '{{itemReviews}}' +
                                  '<p class="text-muted mb-1 product-item__vendor">{{itemVendor}}</p>' +
                                  '<p class="h5 product-item__price">' +
                                    '{{itemPrice}}' +
                                  '</p>' +
                                '</div>' +
      
                                '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>' +
                              '</div>' +
                            '</div>',

    // List Template
    'productListItemHtml': '<div class="col-sm-12 product-item list">' +
                              '<div class="row">' +
                                '<div class="col-3 col-sm-2 d-flex flex-column justify-content-center product-item__card-image {{itemImageClasses}}">' +
                                  '<a href="{{itemUrl}}" title="{{itemTitle}}">' +
                                    '{{itemImages}}' +
                                  '</a>' +
                                '</div>' +
                                '<div class="col-6 col-sm-6 d-flex flex-column justify-content-center">' +
                                  '<p class="h6 product-item__title"><a href="{{itemUrl}}" title="{{itemTitle}}">{{itemTitle}}</a></p>' +
                                  '<p class="text-muted product-item__vendor">{{itemVendor}}</p>' +
                                  '<p class="shopify-product-reviews-badge" data-id="{{itemId}}"></p>' +
                                '</div>' +
                                '<div class="col-3 col-sm-4 d-flex flex-column justify-content-center align-items-end">' +
                                  '{{itemLabels}}' +
                                  '<p class="h6 text-right product-item__price">' +
                                    '{{itemPrice}}' +
                                  '</p>' +
                                '</div>' +
                              '</div>' +
                            '</div>',
    // Pagination Template
    'previousActiveHtml': '<li class="page-item"><a class="page-link" href="{{itemUrl}}">'+bcSfFilterConfig.label_basic.pagination_previous+'</a></li>',
    'previousDisabledHtml': '<li class="page-item disabled"><a class="page-link" href="">'+bcSfFilterConfig.label_basic.pagination_previous+'</a></li>',
    'nextActiveHtml': '<li class="page-item"><a class="page-link" href="{{itemUrl}}">'+bcSfFilterConfig.label_basic.pagination_next+'</a></li>',
    'nextDisabledHtml': '<li class="page-item disabled"><a class="page-link" href="{{itemUrl}}">'+bcSfFilterConfig.label_basic.pagination_next+'</a></li>',
    'pageItemHtml': '<li class="page-item"><a class="page-link" href="{{itemUrl}}" aria-label="Goto page {{itemTitle}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="page-item active"><a class="page-link" href="{{itemUrl}}" aria-label="Goto page {{itemTitle}}">{{itemTitle}}</a></li>',
    'pageItemRemainHtml': '<li class="page-item"><span class="page-link">{{itemTitle}}</span></li>',
    'paginateHtml': '<nav aria-label="Pagination" role="navigation"><ul class="pagination justify-content-center">{{previous}}{{pageItems}}{{next}}</ul></nav>',

    // Sorting Template
    'sortingHtml': '<select class="form-control form-control-sm">{{sortingItems}}</select>',

    // Show Limit Template
    'showLimitHtml': '<label>' + bcSfFilterConfig.label.show_limit + '</label><select class="bc-sf-filter-filter-dropdown">{{showLimitItems}}</select>',

    // Breadcrumb Template
    'breadcrumbHtml': '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> {{breadcrumbDivider}} {{breadcrumbItems}}',
    'breadcrumbDivider': '<span class="divider">/</span>',
    'breadcrumbItemLink': '<a href="{{itemLink}}">{{itemTitle}}</a>',
    'breadcrumbItemSelected': '<span>{{itemTitle}}</span>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  	if (!this.isMobile() && index == 1) {
      	itemHtml = '<div class="col-sm-3 product-item grid"></div>' + itemHtml;
    }

    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Add Custom class

    // Add Grid Width class

    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

    // Add Image classes
    if (images.length > 1) {
      itemHtml = itemHtml.replace(/{{itemImageClasses}}/g, 'hoverable');
    } else {
      itemHtml = itemHtml.replace(/{{itemImageClasses}}/g, '');
    }

    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

  // Reviews
         let itemReviewsHtml = '';
     let metafieldJudgeMe = data.metafields.find(meta => meta.key == "badge" && meta.namespace == "judgeme")
           if (metafieldJudgeMe && metafieldJudgeMe.value !== null) {
             itemReviewsHtml += `<div class='jdgm-widget jdgm-preview-badge' data-id="${data.id}">${metafieldJudgeMe.value}</div>`
           }
           itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {

  // Get Template
  var itemHtml = bcSfFilterTemplate.productListItemHtml;

  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);

  // Add Custom class

  // Add Grid Width class

  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));

  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

  // Add Image classes
  if (images.length > 1) {
    itemHtml = itemHtml.replace(/{{itemImageClasses}}/g, 'hoverable');
  } else {
    itemHtml = itemHtml.replace(/{{itemImageClasses}}/g, '');
  }

  // Add Price
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

  return itemHtml;
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

/************************** END BUILD PRODUCT LIST **************************/

/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

function prepareShopifyData(data) {
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = Object.keys(data.images).map(function (key) { return data.images[key]; });
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    return data;
}

/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

/************************** BUILD PRODUCT ITEM ELEMENTS **************************/


function buildImages(data) {
    var html = '';
    // Build Main Image
    var thumbUrl = images.length > 0 ? bcsffilter.optimizeImage(images[0]) : bcSfFilterConfig.general.no_image_url;
    var secondaryUrl = images[1] ? bcsffilter.optimizeImage(images[1]) : '';
    if (secondaryUrl) {
      html += '<div class="image-ratio ratio-3-2 product-item__secondary-image"><img data-src="'+secondaryUrl+'" class="image-ratio__image lazyload" alt="'+data.title+'"></div>'
    }
    html += '<div class="image-ratio ratio-3-2 product-item__featured-image"><img data-src="'+thumbUrl+'" class="image-ratio__image lazyload" alt="'+data.title+'"></div>'

    return html;
}
function buildVendor(data) {
    var html = '';
    html = bcSfFilterTemplate.vendorHtml;
    return html;
}
function buildPrice(data) {
    var html = '';
    if (data.template_suffix == 'with_meters_and_variants') {
      var foil_width = data.tags.find(function(t){
        return t.includes('foil_width')
      })
      foil_width = foil_width.replace('foil_width-', '') / 100.0
      var square_meter_price = Math.round(data.price_min / foil_width / 100)
      if (data.title.includes('Stenfolie')) {
        html += '<span>'+slate.Currency.formatMoney(data.price_min, theme.moneyFormat)+' / meter</span>'
      } else {
        html += '<span>'+square_meter_price+' kr. / m<sup>2</sup></span>'
      }
      if (onSale) {
        if (data.title.includes('Stenfolie')) {
          html += ' <s>'+slate.Currency.formatMoney(data.compare_at_price_min, theme.moneyFormat)+'</s> ';
        } else {
          var before_square_meter_price = Math.round(data.compare_at_price_min / foil_width / 100)
          html += ' <s>'+before_square_meter_price+' kr.</s> ';
        }
      }
    } else {
      if (priceVaries) {
        html += (bcSfFilterConfig.label_basic.from) + ' ';
      }
      // TODO: FIX with proper api data
      if (data.product_type == "Gavekort") {
        var taxable = false
      }
      html += '<span>' + slate.Currency.formatMoney(data.price_min, theme.moneyFormat, taxable) + '</span>';
      if (onSale) {
        html += ' <s>' + slate.Currency.formatMoney(data.compare_at_price_min, theme.moneyFormat, taxable) + '</s> ';
      }
    }
    return html;
}
function buildLabels(data) {
    // Build Sold out label
    var soldOutLabel = '';
    if (soldOut) {
        soldOutLabel = bcSfFilterTemplate.soldOutLabelHtml
    }
    // Build Sale label
    var saleLabel = '';
    if (onSale && !soldOut) {
        var money_saved = (data.compare_at_price_min - data.price_min) * 100
        var percent_saved = Math.floor(money_saved / data.compare_at_price_min)
        // saleLabel = bcSfFilterTemplate.saleLabelHtml
        saleLabel = bcSfFilterTemplate.saleLabelHtml.replace(/{{itemPercent}}/g, percent_saved);
    }
    // Build Labels
    var html = soldOutLabel + saleLabel;
    return html
}

/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/

/************************** BUILD TOOLBAR **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var limit = this.queryParams.limit | bcSfFilterConfig.settings.general.limit
    var totalPage = Math.ceil(totalProduct / limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);
            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
    if (bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
        jQ(this.selector.topShowLimit).html('');

        var numberList = this.getSettingValue('general.showLimitList');
        if (numberList != '') {
            // Build content
            var showLimitItemsHtml = '';
            var arr = numberList.split(',');
            for (var k = 0; k < arr.length; k++) {
                showLimitItemsHtml += '<option value="' + arr[k].trim() +'">' + arr[k].trim() + '</option>';
            }
            var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
            jQ(this.selector.topShowLimit).html(html);
            // Set value
            jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
        }
    }
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
    var itemHtml = '<span class="d-none d-md-inline-block">'+bcSfFilterConfig.label.view_as+' </span>';
    itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid bc-sf-filter-sprite" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
    itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list bc-sf-filter-sprite" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
    jQ(this.selector.topDisplayType).html(itemHtml);

    // Active current display type
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
    jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
    if (this.queryParams.display == 'list') {
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
    } else if (this.queryParams.display == 'grid') {
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
    }
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
    if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
        var breadcrumbItemsHtml = '';
        if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
            var colInfo = colData.collection;
            if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
                breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
                breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
                breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
            } else {
                breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
            }
        } else {
            breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue('label.defaultCollectionHeader'));
        }
        var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, breadcrumbItemsHtml)
        html = html.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider);
        jQ(this.selector.breadcrumb).html(html);
    }
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  this.buildRobotsMetaTag();
  var totalProduct = '';

  if (data.total_product == 1) {
      totalProduct = bcSfFilterConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
  } else {
      totalProduct = bcSfFilterConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
  }
  jQ("span.bc-sf-filter-option-value").each(function( index ) {
      if(jQ(this).text().toLowerCase().indexOf("taxable_") > -1 ){
		jQ(this).parents('li').remove()
      }
    });
  jQ('#bc-sf-filter-total-product').html(totalProduct);
    if (window.SPR) { //Product reviews
        SPR.registerCallbacks()
        SPR.initRatingHandler();
        SPR.initDomEls();
        SPR.loadProducts();
        SPR.loadBadges();
    }

};

BCSfFilter.prototype.beforeBuildFilterTree = function(data, filterTreeId) {
    // Clear all content in the filter tree before building
    jQ(this.getSelector('filterTree') + filterTreeId).html('');
    // Remove Vendor filter option in the Vendor page
    data = this.removeVendorOptionInVendorPage(data, filterTreeId);

  	for (var a in data) {
      	var filter = data[a];
      	if (filter.filterType != 'price') {
          	filter.displayType = 'box';
        }
    }

    return data;
};

BCSfFilter.prototype.afterBuildFilterTree = function(data, filterTreeId) {
    // Wrap all filter option blocks for styling
    jQ(this.getSelector('filterTree') + filterTreeId).children().wrapAll('<div id="bc-sf-filter-options-wrapper"></div>');
    // Box Style
    this.buildFilterOptionBoxStyle(null, filterTreeId);

  	var height = jQ('.product-item__card').outerHeight();
  	jQ('.bc-sf-filter-tree-customization').css('max-height', height+'px');

    // Add scroll bar for block has long content, except the filter option which is range
    this.buildFilterShowMore();
    // Collapse all filter options by default
    if (!this.checkIsFullWidthMobile()) this.collapseFilterOption();


};

function closeFilterMobile() {
    jQ('#bc-sf-filter-tree').removeClass('bc-sf-filter-tree-mobile-open');
  	jQ('body').removeClass('show-overlay');
}

BCSfFilter.prototype.buildFilterTreeMobileButtonEvent = function() {
    var _this = this;
    var filterSelector = this.getSelector('filterTree');
    var mobileBtnSelector = this.getSelector('filterTreeMobileButton');

    jQ(mobileBtnSelector).unbind('click');
    jQ(mobileBtnSelector).on('click', function() {
        var style = _this.mobileStyle;
        // Full Width style
        if (style == 'style2' || style == 'style3') {
            jQ(filterSelector).toggleClass('bc-sf-filter-tree-mobile-open');
            // Build mobile content
            _this.buildFilterTreeMobile();
            // Remove scrollbar
            _this.removeScrollbar(jQ('.' + _this.class.filterBlockContent));
        }
        // Default style
        else {
            // Change button text when clicking
            if (_this.getSettingValue('general.changeMobileButtonLabel')) {
                var openClass = _this.class.mobileButtonOpen;
                jQ(this).toggleClass(openClass);
                var label = jQ(this).hasClass(openClass) ? _this.getSettingValue('label.refineMobileCollapse') : _this.getSettingValue('label.refineMobile');
                jQ(this).text(label);
            }

            jQ(filterSelector).slideToggle(function () {
                jQ(filterSelector).toggleClass('bc-sf-filter-tree-mobile-open');
                _this.buildFilterOptionBoxStyle(jQ(this));
                // Re-initialize jscrollpane
                _this.buildFilterScrollbar();
            });
        }
      	jQ('body').addClass('show-overlay');
    });
};
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */


/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
